import { render, staticRenderFns } from "./setPassWord.vue?vue&type=template&id=04bfe2de&scoped=true"
import script from "./setPassWord.vue?vue&type=script&lang=ts"
export * from "./setPassWord.vue?vue&type=script&lang=ts"
import style0 from "./setPassWord.vue?vue&type=style&index=0&id=04bfe2de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bfe2de",
  null
  
)

export default component.exports